import { render, staticRenderFns } from "./detail-description.component.vue?vue&type=template&id=234be336"
import script from "./detail-description.component.ts?vue&type=script&lang=ts&external"
export * from "./detail-description.component.ts?vue&type=script&lang=ts&external"
import style0 from "./detail-description.component.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports